/**
 * Public support inbox (mailto links, help UI, report-error recipient).
 * Set `NEXT_PUBLIC_SUPPORT_EMAIL` so the value is correct in the browser bundle.
 * Optional server-only override: `SUPPORT_CONTACT_EMAIL` (e.g. same address, or an internal alias).
 */
function resolveSupportEmail(): string {
  const pub = process.env.NEXT_PUBLIC_SUPPORT_EMAIL?.trim();
  if (pub) return pub;
  const server = typeof window === "undefined" ? process.env.SUPPORT_CONTACT_EMAIL?.trim() : undefined;
  if (server) return server;
  return "support@jorvioquotes.com";
}

export const SUPPORT_EMAIL = resolveSupportEmail();
